import { arrayOfType } from '../../utils/util-functions';
import { IScoreCardSection, ScoreCardSectionModel } from './scorecard-section.model';
import { IScorecardChallenge, ScorecardChallengeModel } from './challenge.model';

export type TTriggerConditionKey = 'FirstTimeProspect' | 'FirstTimeProspectEnglishOnly' | 'Custom' | null;

export interface IScorecard {
  siteId: number;
  siteName: string;
  accountId: number;
  accountName: string;
  agentName: string;
  conversationId: number;
  routingUniqueId: string;
  callDetailRecordId: number;
  scorecardId: number;
  scorecardKey: string;
  scorecardName: string;
  startDate: string;
  scoredDate: string;
  duration: string;
  sections: IScoreCardSection[];
  version: string;
  challenges: IScorecardChallenge[];
  triggerConditionKey: TTriggerConditionKey;
}

export class ScorecardModel implements IScorecard {
  siteId: number = 0;
  siteName: string = '';
  accountId: number = 0;
  accountName: string = '';
  agentName: string = '';
  conversationId: number = 0;
  routingUniqueId: string = '';
  callDetailRecordId: number = 0;
  scorecardId: number = 0;
  scorecardKey: string = '';
  scorecardName: string = '';
  startDate: string = '';
  scoredDate: string = '';
  duration: string = '';
  sections: IScoreCardSection[] = [];
  version: string = '';
  challenges: IScorecardChallenge[];
  triggerConditionKey: TTriggerConditionKey = null;

  constructor(data?: IScorecard) {
    this.siteName = data?.siteName ?? this.siteName;
    this.accountId = data?.accountId ?? this.accountId;
    this.accountName = data?.accountName ?? this.accountName;
    this.agentName = data?.agentName ?? this.agentName;
    this.conversationId = data?.conversationId ?? this.conversationId;
    this.routingUniqueId = data?.routingUniqueId ?? this.routingUniqueId;
    this.callDetailRecordId = data?.callDetailRecordId ?? this.callDetailRecordId;
    this.scorecardId = data?.scorecardId ?? this.scorecardId;
    this.scorecardKey = data?.scorecardKey ?? this.scorecardKey;
    this.scorecardName = data?.scorecardName ?? this.scorecardName;
    this.startDate = data?.startDate ?? this.startDate;
    this.scoredDate = data?.scoredDate ?? this.scoredDate;
    this.duration = data?.duration ?? this.duration;
    this.challenges = arrayOfType<IScorecardChallenge>(data?.challenges, ScorecardChallengeModel);
    this.sections = arrayOfType<IScoreCardSection>(data?.sections, ScoreCardSectionModel);
    this.version = data?.version ?? this.version;
    this.triggerConditionKey = data?.triggerConditionKey ?? this.triggerConditionKey;
  }
}
